import { InputProps, Skeleton, Typography } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import { FieldInputProps } from 'formik'
import { ChangeEvent, FC } from 'react'
import { formatPhoneNumber } from 'react-phone-number-input'
import FormikPhoneInput from 'shared/components/FormikPhoneInput/FormikPhoneInput'
import NonFormikPhoneInput from 'shared/components/NonFormikPhoneInput'
import { getPxAsRem } from 'shared/utils'
import { StyledInputLabel } from '../styled'

interface ToggleEditTextFieldProps extends FieldInputProps<string> {
    edit: boolean
    disabled?: boolean
    loading?: boolean
    error?: boolean
    helperText?: string
    label: string
    value: string
    id?: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    mask?: 'formikPhone' | 'phone' | undefined
    InputProps?: InputProps
}

const ToggleEditTextField: FC<ToggleEditTextFieldProps> = ({
    edit,
    label,
    onChange,
    value,
    disabled,
    loading,
    error,
    helperText,
    id,
    mask,
    InputProps,
    ...props
}) => {
    if (loading)
        return (
            <>
                <InputLabel>{label}</InputLabel>
                <Skeleton>
                    <TextField fullWidth />
                </Skeleton>
            </>
        )
    if (edit)
        return mask === 'formikPhone' ? (
            <FormikPhoneInput
                {...props}
                id={id}
                label={label}
                value={value}
                onChange={onChange}
                fieldName="phone"
                disabled={disabled}
                error={error}
                helperText={helperText}
                InputProps={{
                    sx: { padding: `${getPxAsRem(8, 0, 8, 6)} !important` },
                    ...InputProps,
                }}
            />
        ) : mask === 'phone' ? (
            <NonFormikPhoneInput
                {...props}
                id={id}
                label={label}
                value={value}
                handleInputChange={onChange}
                disabled={disabled}
                error={error}
                helperText={helperText}
                InputProps={{
                    sx: { padding: `${getPxAsRem(8, 0, 8, 6)} !important` },
                    ...InputProps,
                }}
                sx={{
                    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                        paddingLeft: getPxAsRem(52),
                        paddingTop: getPxAsRem(6),
                    },
                }}
            />
        ) : (
            <TextField
                {...props}
                id={id}
                label={label}
                value={value}
                onChange={onChange}
                fullWidth
                disabled={disabled}
                error={error}
                helperText={helperText}
                InputProps={{
                    sx: { padding: `${getPxAsRem(8, 0, 8, 6)} !important` },
                    ...InputProps,
                }}
            />
        )

    return (
        <>
            <StyledInputLabel>{label}</StyledInputLabel>
            <Typography variant="body1">
                {mask && value ? formatPhoneNumber(value) : value || '-'}
            </Typography>
        </>
    )
}

export default ToggleEditTextField
